import React from 'react';
import { connect } from 'react-redux';

import {
  ResourcesList, isFinishedFetching, getTimeSinceLastSync, isNotAvailableLocally,
} from 'redux-and-the-rest';
import { GameScoreModel } from '../../models/gameScoreModel';
import LoadingIndicator from '../shared/LoadingIndicator';
import { getOrFetchLeaderboardGameScores } from '../../redux/reducers/leaderboardGameScoresReducer';
import { ApplicationState } from '../../redux/types';
import HighScore from './HighScore';

interface Props {
  leaderboardGameScores: ResourcesList<GameScoreModel>;
}

const Leaderboard = ({ leaderboardGameScores }: Props): React.ReactElement => {
  if (!isFinishedFetching(leaderboardGameScores)) {
    return <LoadingIndicator />;
  }

  if (leaderboardGameScores.items.length === 0) {
    return (
      <p>
        Start playing games on your classroom islands to generate a high score within each game!
      </p>
    );
  }

  return (
    <div className="leaderboard loadable form">
      <div className="list">
        {leaderboardGameScores.items.map(({ values }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="list-item">
            <HighScore gameScore={values} highScore />
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (
  { leaderboardGameScores }: ApplicationState,
) => ({
  leaderboardGameScores: getOrFetchLeaderboardGameScores(leaderboardGameScores, { include: 'game,island' }, {
    /**
     * Reload game scores if they haven't been fetched yet, or they're more than 10 seconds old
     * @param list
     */
    forceFetch: (list: ResourcesList<GameScoreModel>) => isNotAvailableLocally(list) || (isFinishedFetching(list) && getTimeSinceLastSync(list) > 10000),
  }),
});

export default connect(mapStateToProps)(Leaderboard);
